import printTankersComponent from './print_tankers.component';

let printTankersModule = angular.module('printTankers', [
	])
	.config(($stateProvider, $urlRouterProvider) => {
		"ngInject";

		$urlRouterProvider.otherwise('/tankers-history');

		$stateProvider
			.state('printTankers', {
				url: '/print-tankers',
				component: 'printTankers',
				data: {
					requireLogin: true,
				},
			});
	})

	.component('printTankers', printTankersComponent)

	.name;

export default printTankersModule;




// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/tankers/print/index.js